<template>
  <div class="level__title-wrapper">
    <p class="level__title">
      <span>
        {{ title }}
      </span>
      <label
        :class="[
          textClass ? `level__title__label--${textClass}` : '',
          'level__title__label',
        ]"
        v-if="hasAccess"
      >
        {{ details }}
      </label>
    </p>
  </div>
</template>

<script>
export default {
  name: 'LevelTitle',
  props: {
    title: {
      type: String,
      required: true,
    },
    details: {
      type: String,
      default: 'level details',
      required: false,
    },
    labType: {
      type: String,
      required: false,
    },
    textClass: {
      type: String,
      required: false,
    },
    hasAccess: {
      type: Boolean,
      required: true,
    },
  },
}
</script>
